import React from 'react';
import { Box, Text, Heading } from '@wix/design-system';
import { PricingStrategy } from '@wix/ambassador-premium-domains-v1-display-price/types';
import styles from './TldPromotion.scss';
import { DomainSearchSuiteModule } from '../../../module/domainSearchSuite.module';
import { AITldDisclaimer } from '../../AITldDisclaimer/AITldDisclaimer';
import { useIsMobile } from '@wix/core-domain-search';
export const TldPromotionPrice = _ref => {
  let pricing = _ref.pricing,
    tld = _ref.tld;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  const shouldShowAIDisclaimer = tld === 'ai' && pricing.pricingStrategy === PricingStrategy.MULTI_YEAR_MINIMUM_COUNT;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "2px"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "SP1",
    align: "right",
    className: styles.priceText
  }, pricing.originalPrice && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    secondary: true,
    light: true,
    className: styles.disabledText
  }, t('domain_search_suite.domain_gate.tld_section.domain_price', {
    domainPrice: pricing.originalPrice
  })), pricing.price && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal"
  }, t('domain_search_suite.domain_gate.tld_section.domain_price', {
    domainPrice: pricing.price
  }))), shouldShowAIDisclaimer ? /*#__PURE__*/React.createElement(AITldDisclaimer, null) : null);
};
export const TldPromotionContent = _ref2 => {
  let tld = _ref2.tld,
    pricing = _ref2.pricing,
    description = _ref2.description,
    Label = _ref2.Label,
    PromotionBadge = _ref2.PromotionBadge,
    PromotionPrice = _ref2.PromotionPrice;
  const _DomainSearchSuiteMod2 = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod2.t;
  const isMobile = useIsMobile();
  const pricingLabel = (pricing == null ? void 0 : pricing.pricingStrategy) === PricingStrategy.FREE_FIRST_YEAR ? Label ? /*#__PURE__*/React.createElement(Label, {
    pricing: pricing
  }) : t('domain_search_suite.domain_gate.tld_section.badge.free_with_plan') : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: isMobile ? '6px' : '52px'
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: isMobile ? '6px' : '20px'
  }, /*#__PURE__*/React.createElement(Box, {
    minHeight: "18px"
  }, PromotionBadge ? /*#__PURE__*/React.createElement(PromotionBadge, {
    pricing: pricing,
    tld: tld
  }) : pricingLabel && /*#__PURE__*/React.createElement(Box, {
    padding: "3px 6px",
    width: "max-content",
    backgroundColor: "#DFF994",
    borderRadius: "4px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal",
    className: styles.labelText
  }, pricingLabel))), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "50px",
    maxWidth: "200px"
  }, /*#__PURE__*/React.createElement(Heading, {
    className: styles.tld,
    size: "extraLarge"
  }, ".", tld))), /*#__PURE__*/React.createElement(Box, null, description && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true,
    className: styles.descriptionText
  }, description))), pricing && PromotionPrice && /*#__PURE__*/React.createElement(PromotionPrice, {
    pricing: pricing,
    tld: tld
  }), pricing && !PromotionPrice && /*#__PURE__*/React.createElement(TldPromotionPrice, {
    pricing: pricing,
    tld: tld
  }));
};
//# sourceMappingURL=TldPromotionContent.js.map